import { getSafeHttpUrl } from '@/helpers/url';
import { ContentCopy } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { type MouseEvent, useEffect, useMemo, useRef, useState } from 'react';

interface IProps {
  value: string;
}

const VideoUrlCell = ({ value }: IProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const closeTimerRef = useRef<number | null>(null);

  const safeUrl = useMemo(() => (value ? getSafeHttpUrl(value) : null), [value]);

  useEffect(() => {
    return () => {
      if (closeTimerRef.current !== null) window.clearTimeout(closeTimerRef.current);
    };
  }, []);

  const onCopyClick = async (e: MouseEvent) => {
    e.stopPropagation();
    if (safeUrl) {
      await navigator.clipboard.writeText(safeUrl);
      setOpen(true);
      setTimeout(() => setOpen(false), 700);
    }
  };

  if (!safeUrl) return <span>Processing</span>;

  return (
    <div className='flex items-center justify-between w-full overflow-hidden'>
      <a
        href={safeUrl}
        target='_blank'
        rel='noopener noreferrer'
        className='overflow-hidden text-ellipsis whitespace-nowrap text-blue-500 hover:underline'
        title={safeUrl}
      >
        {safeUrl}
      </a>
      <Tooltip title='Copied' open={open} placement='top'>
        <IconButton aria-label='copy' onClick={onCopyClick} size='small' className='ml-1'>
          <ContentCopy sx={{ width: '14px', height: '14px' }} />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default VideoUrlCell;
